import React from "react";
import { Grid, Button, Hidden, CardMedia } from "@mui/material";
import "../style/style.css";
import unsplash from "../api/unsplash";
import { useNavigate } from "react-router-dom";
import GlobalSnackbar from "./Snackbar";
import Safety from "../assets/images/Safety_sx.jpeg";

class SetPassword extends React.Component {
  constructor() {
    super();

    this.state = {
      passwordShown: false,
      confirmPasswordShown: false,
      openSnack: false,
      isTokenValid: false,
      isCheckingToken: true,
      username: "",
      snack: {
        severity: "success",
        messaggio: "Salvataggio Effettuato correttamente",
        open: false,
      },
      icon: "bi bi-eye-slash-fill",
      confirmIcon: "bi bi-eye-slash-fill",
    };
  }
  handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ openSnack: false });
  };
  componentDidMount = async () => {
    //Coloro lo sfondo solo qui
    document.body.style.backgroundColor = "rgb(238, 242, 246)";

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");

    if (!token) {
      this.setState({ isCheckingToken: false, isTokenValid: false });
      return;
    }

    try {
      const response = await unsplash.post("utentiPasswordSetup", {
        operation: "verifyToken",
        token,
      });

      this.setState({
        isCheckingToken: false,
        isTokenValid: response.data.valid === true,
        username: response.data.username || "",
      });
    } catch (error) {
      this.setState({ isCheckingToken: false, isTokenValid: false });
    }
  };
  handleEyeClick = () => {
    this.setState({ passwordShown: !this.state.passwordShown });

    this.state.passwordShown
      ? this.setState({ icon: "bi bi-eye-slash-fill" })
      : this.setState({ icon: "bi bi-eye-fill" });
  };
  handleConfirmEyeClick = () => {
    this.setState({ confirmPasswordShown: !this.state.confirmPasswordShown });

    this.state.confirmPasswordShown
      ? this.setState({ confirmIcon: "bi bi-eye-slash-fill" })
      : this.setState({ confirmIcon: "bi bi-eye-fill" });
  };
  handleCreate = async (event) => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");

    event.preventDefault();

    if (!token) {
      this.setState({
        snack: {
          severity: "error",
          messaggio: "ERRORE DURANTE IL CAMBIO PASSWORD",
        },
      });
      this.setState({ openSnack: true });
      return;
    }

    if (!this.state.isTokenValid) {
      this.setState({
        snack: {
          severity: "error",
          messaggio: "LINK NON PIU VALIDO",
        },
      });
      this.setState({ openSnack: true });
      return;
    }

    if (
      !this.password.value ||
      this.password.value !== this.confirmPassword.value
    ) {
      this.setState({
        snack: {
          severity: "warning",
          messaggio: "Attenzione le password non coincidono",
        },
      });
      this.setState({ openSnack: true });
      return;
    }

    try {
      const response = await unsplash.post("utentiPasswordSetup", {
        operation: "changePassword",
        token,
        password: this.password.value,
      });

      if (response.data.message === "utente updated successfully") {
        this.props.navigate("/login");
        return;
      }

      this.setState({
        snack: {
          severity: "error",
          messaggio: "ERRORE DURANTE IL CAMBIO PASSWORD",
        },
      });
      this.setState({ openSnack: true });
    } catch (error) {
      this.setState({
        snack: {
          severity: "error",
          messaggio: "LINK NON PIU VALIDO O SCADUTO",
        },
      });
      this.setState({ openSnack: true });
    }
  };

  render() {
    return (
      <>
        <GlobalSnackbar
          severity={this.state.snack.severity}
          messaggio={this.state.snack.messaggio}
          openSnack={this.state.openSnack}
          handleCloseSnack={this.handleCloseSnack}
        />
        <Grid
          container
          spacing={0}
          direction="row"
          alignItems="center"
          display="flex"
          minHeight="100vh"
          flexWrap="nowrap"
        >
          <Hidden mdDown>
            <Grid
              xs={6}
              sx={{
                margin: "30px",
                borderRadius: "8px",
              }}
            >
              <CardMedia
                sx={{ borderRadius: "8px", height: "calc(100vh - 4rem)" }}
                component="img"
                image={Safety}
                alt="Safety"
              />
            </Grid>
          </Hidden>
          <Grid
            xs={8}
            lg={4}
            justifyContent="center"
            alignItems="center"
            display="flex"
            flexWrap="wrap"
            gap={4}
            style={{ margin: "0 auto" }}
          >
            <img
              src={require("../assets/images/logo.png")}
              className="max-w-full h-auto"
              width="500px"
              alt=""
            />

            {this.state.isCheckingToken ? (
              <p className="fs-5" style={{ color: "#11526f" }}>
                Verifica link in corso...
              </p>
            ) : !this.state.isTokenValid ? (
              <p className="fs-5" style={{ color: "#11526f" }}>
                ATTENZIONE LINK NON PIU VALIDO
              </p>
            ) : (
              <form style={{ width: "100%", maxWidth: "440px" }}>
                {this.state.username ? (
                  <p className="fs-6" style={{ color: "#11526f" }}>
                    Username: <b>{this.state.username}</b>
                  </p>
                ) : null}
                <label className="form-label fs-5" htmlFor="password">
                  Inserisci Password
                </label>
                <div className="form-outline mb-4 input-group">
                  <input
                    type={this.state.passwordShown ? "text" : "password"}
                    id="password"
                    name="password"
                    placeholder="Inserisci la password"
                    ref={(password) => (this.password = password)}
                    className="block appearance-none w-full mb-1 text-gray-800 border border-gray-200 py-2 px-4 text-lg leading-normal rounded bg-white fs-6"
                  />
                  <span className="input-group-text bg-transparent">
                    <i
                      className={this.state.icon}
                      style={{ cursor: "pointer" }}
                      onClick={this.handleEyeClick}
                    ></i>
                  </span>
                </div>
                <label className="form-label fs-5" htmlFor="confirm-password">
                  Conferma Password
                </label>
                <div className="form-outline mb-4 input-group">
                  <input
                    type={this.state.confirmPasswordShown ? "text" : "password"}
                    id="confirm-password"
                    name="confirm-password"
                    placeholder="Conferma la password"
                    ref={(confirmPassword) =>
                      (this.confirmPassword = confirmPassword)
                    }
                    className="block appearance-none w-full mb-1 text-gray-800 border border-gray-200 py-2 px-4 text-lg leading-normal rounded bg-white fs-6"
                  />
                  <span className="input-group-text bg-transparent">
                    <i
                      className={this.state.confirmIcon}
                      style={{ cursor: "pointer" }}
                      onClick={this.handleConfirmEyeClick}
                    ></i>
                  </span>
                </div>

                <div className="d-flex justify-content-around align-items-center mb-4"></div>

                <Button
                  fullWidth
                  size="large"
                  variant="contained"
                  className="ButtonMiller"
                  onClick={this.handleCreate}
                >
                  Conferma
                </Button>
              </form>
            )}
          </Grid>
        </Grid>
      </>
    );
  }
}

function WithNavigate(props) {
  const navigate = useNavigate();

  return <SetPassword {...props} navigate={navigate} />;
}

export default WithNavigate;
